<mat-card class="scheda">
  <mat-card-title
    ><h3 class="center">{{ title }}</h3></mat-card-title
  >

  <mat-card-content class="p-3">
    <button
      class="m-1"
      mat-mini-fab
      color="primary"
      matTooltip="Aggiungi immagine (max. {{ max }})"
      [matMenuTriggerFor]="imageTypeMenu"
      [disabled]="images.length >= max"
      *ngIf="!insert"
    >
      <mat-icon>add</mat-icon>
    </button>

    <mat-menu #imageTypeMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let type of imageTypes"
        (click)="selectImageType(type)"
        [disabled]="isTypeDisabled(type)"
      >
        <span>{{ type.label }}</span>
        <small *ngIf="type.description" class="d-block text-muted">{{ type.description }}</small>
      </button>
    </mat-menu>
    <button
      class="m-1"
      mat-mini-fab
      color="primary"
      matTooltip="Rimuovi immagine"
      (click)="removeImage()"
      *ngIf="!insert"
    >
      <mat-icon>clear</mat-icon>
    </button>
    <input
      #file
      type="file"
      accept="image/*"
      (change)="addImage($event)"
      class="hide"
    />

    <div class="images-grid" *ngIf="!loading">
      <div
        class="imageContainer"
        *ngFor="let image of images; let i = index"
      >
        <img [src]="image" class="image" [alt]="imageLabels[i]" />
        <div class="image-label-overlay" *ngIf="imageLabels[i]">{{ imageLabels[i] }}</div>
      </div>
    </div>
    <div *ngIf="loading">
      <mat-spinner [diameter]="35" class="mx-auto"></mat-spinner>
    </div>
  </mat-card-content>
</mat-card>
